var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_c('img',{staticClass:"footer-back",attrs:{"src":require('../../assets/imgs/icon/footer-back.png')},on:{"click":this.onBack}}),_vm._v(" "),_c('div',{staticClass:"home-button",on:{"click":this.onButtonClick}},[_vm._v(_vm._s(this.text)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47816046","hasScoped":true,"transformToRequire":{"video":["app","poster"],"source":"app","img":"app","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/components/footer/MoreFooter.vue
// module id = null
// module chunks = 